export const STANDARD_NUMBER_PREFIX = 'STD-';
export const CUSTOM_NUMBER_PREFIX = 'CTM-';
export const NUMBER_PAD_LENGTH = 6;

const nextNumberWithPrefix = (products, prefix) => {
  const pattern = new RegExp(`^${prefix}\\d{${NUMBER_PAD_LENGTH},}$`);
  const used = products
    .map((product) => product.internalNumber)
    .filter((internalNumber) => pattern.test(internalNumber || ''))
    .map((internalNumber) => Number(internalNumber.slice(prefix.length)));
  const next = used.length > 0 ? Math.max(...used) + 1 : 1;
  return `${prefix}${String(next).padStart(NUMBER_PAD_LENGTH, '0')}`;
};

export const nextCustomProductNumber = (products) => (
  nextNumberWithPrefix(products, CUSTOM_NUMBER_PREFIX)
);

export const nextStandardFallbackNumber = (products) => (
  nextNumberWithPrefix(products, STANDARD_NUMBER_PREFIX)
);

export const getDisplayNumber = (product) => (
  product?.productType === 'Custom'
    ? product.internalNumber
    : (product?.supplierItemNumber || product?.internalNumber)
);
